<template>
  <v-toolbar class="elevation-0 edit-actions" height="23" color="transparent">
    <v-spacer></v-spacer>
    <v-btn
      icon
      :color="color"
      class="mt-5"
      outline
      small
      @click="edit"
      title="Editar Campos"
      v-if="isDisplayMode"
      >
      <v-icon size="20" :color="color">edit</v-icon>
    </v-btn>
    <template v-else>
      <v-btn
        icon
        class="mt-5"
        @click="save"
        small
        :disabled="!valid"
        title="Salvar edição"
        >
        <v-icon :color="color">save</v-icon>
      </v-btn>
      <v-btn
        icon
        small
        class="mt-5"
        title="Cancelar edição"
        @click="cancel"
        >
        <v-icon :color="color">cancel</v-icon>
      </v-btn>

    </template>
  </v-toolbar>
</template>

<script>
  export default {
    props: {
      displayMode: {
        type: Boolean,
        default: true
      },
      dark: {
        type: Boolean,
        default: false
      },
      valid: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        isDisplayMode: {}
      }
    },
    methods: {
      save () {
        // this.isDisplayMode = true
        this.$emit('save')
      },
      edit () {
        this.isDisplayMode = false
        this.$emit('change', this.isDisplayMode)
      },
      cancel () {
        this.isDisplayMode = true
        this.$emit('change', this.isDisplayMode)
        this.$emit('cancel')
      }
    },
    watch: {
      displayMode (val) {
        this.isDisplayMode = val
      }
    },
    computed: {
      color () {
        return this.dark ? 'darkGray' : 'white'
      }
    },
    mounted () {
      this.isDisplayMode = this.displayMode
    }
  }
</script>

<style lang="sass">
  .edit-actions
    top: -70px
    height: 1px
    max-height: 1px
    // margin-bottom: 15px

    .v-toolbar__content
      padding: 8px

  .config-page
    .edit-actions
      // margin-bottom: 35px

      .v-btn
        background-color: transparent !important

</style>
